<template>
  <div class="app-carousel-pagination">
    <div class="app-carousel-dot-container">
      <button
        v-for="(page, index) in count"
        :key="`${page}_${index}`"
        class="app-carousel-dot"
        :class="{ 'app-carousel-dot--active': index === current }"
        :style="dotStyle"
        @click="goToPage(index)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

defineOptions({
  name: "app-carousel-pagination",
});

const props = defineProps({
  current: {
    type: Number,
    required: true,
  },
  count: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(["paginationClick"]);

const maxPaginationDotCount = ref(3);
const paginationPadding = ref(4);
const paginationSize = ref(8);

const dotStyle = computed(() => {
  const eachDotsWidth = paginationSize.value + paginationPadding.value * 2;
  const maxReverse = props.count - maxPaginationDotCount.value;
  const translateAmount =
    props.current > maxReverse
      ? maxReverse
      : props.current <= maxPaginationDotCount.value / 2
        ? 0
        : props.current - Math.ceil(maxPaginationDotCount.value / 2) + 1;
  const transformWidth = 0 - eachDotsWidth * translateAmount;
  return {
    "-webkit-transform": `translate3d(${transformWidth}px,0,0)`,
    transform: `translate3d(${transformWidth}px,0,0)`,
  };
});

const goToPage = (index: number) => {
  emit("paginationClick", index);
};
</script>

<style scoped lang="scss">
@import "./index";
</style>
